import { useSnackbar } from "notistack";
import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { Panel } from "primereact/panel";
import { SetorForm } from "./SetorForm";
import { useCreateSetor1Mutation, useCreateSetorMutation } from "./setorApiSlice";
import errorFormat from "../../utils/errorFormat";
import { useNavigate } from "react-router-dom";
import configUrls from "../../config/configUrls";
import { ISsetor, Setor } from "../../types/setor/Setor";
import { Secretaria } from "../../types/secretaria/Secretaria";
import { useSetorRoutes } from "../../config/useSetorRoutes";


export const SetorCreate = () => {
    const setorRoutes = useSetorRoutes();

    const [setor, setSetor] = useState<Setor>(ISsetor);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createSetor, status] = useCreateSetor1Mutation();
    const navigate = useNavigate();


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setSetor((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    const handleCepChange = (newCep: string) => {
        // Aqui você pode atualizar o estado com o novo valor de CEP
        setSetor((prev) => ({
            ...prev,
            cep: newCep,
        }));
    };

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        await createSetor(setor);
    }

    useEffect(() => {
        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(setorRoutes.SETOR_LIST);
            // setSetor(ISsetor);          

        }
    }, [status]);



    const handleSearchSecretariaChange = (parSecretaria: Secretaria | null) => {
        setSetor((prev) => ({
            ...prev,
            secretaria: parSecretaria ? {
                ...prev.secretaria,
                id: parSecretaria.id || "",
                nome: parSecretaria.nome || "",

            } : null // Se parOrgao for null, deixa o orgao como null
        }));
    };








    return (



        <>


            <Paper>

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Cadastro de Setores
                </Typography>



                <SetorForm
                    data={setor}
                    // isdisabled={status.isLoading}
                    //isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                    handleCepChange={handleCepChange}
                    handleSearchSecretariaChange={handleSearchSecretariaChange}
                />

            </Paper>










        </>







    );










};

/*
 <SetorTurmaForm
                    setorTurma={setorTurmaState}
                    isdisabled={status.isLoading}
                    isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
*/